<template>
  <v-row class="ma-8 pt-8">
    <!-- role management -->
    <!-- PERMISSION RELEVANT! -->
    <v-col v-if="appUserCanEditRoles" class="col-12">
      <v-card outlined>
        <v-card-title>
          {{ $t('settingsOverview.manageRoles') }}
        </v-card-title>
        <v-card-text>
          <role-management />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- product import -->
    <!-- PERMISSION RELEVANT ! -->
    <v-col v-if="appUserCanUploadExcelImporter" class="col-12">
      <v-card outlined>
        <v-card-title>
          {{ $t('settingsOverview.productsImport') }}
        </v-card-title>
        <v-card-text>
          <products-import />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Change currency -->
    <!-- PERMISSION RELEVANT ? -->
    <v-col v-if="appUserCanEditRegion" class="col-12">
      <v-card outlined>
        <v-card-title>
          {{ $t('settingsOverview.changeCurrency') }}
        </v-card-title>
        <v-card-text>
          <change-currrency />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- power BI edit -->
    <v-col v-if="appUserCanEditPowerBi && appUserCanEditRoles" class="col-12">
      <v-card outlined>
        <v-card-title>
          {{ $t('settingsOverview.powerBi') }}
        </v-card-title>
        <v-card-text>
          <power-bi-management />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import definitions from '../../../../definitions'
import RoleManagement from '../../settings/RoleManagement'
import ProductsImport from '../../settings/ProductsImport'
import PowerBiManagement from '../../settings/PowerBiManagement'
import ChangeCurrrency from '../../settings/ChangeCurrrency'

export default {
  name: 'SettingsOverview',
  components: {
    ProductsImport,
    RoleManagement,
    ChangeCurrrency,
    PowerBiManagement,
  },
  asyncComputed: {
    async appUserCanEditRoles() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.shopApi.BOOKING_CRUD_USER_ROLE_LINK
        )
    },
    async appUserCanUploadExcelImporter() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.engine.PE_POST_IMPORTS
        )
    },
    async appUserCanEditRegion() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.shopApi.EDIT_REGION
        )
    },
    async appUserCanEditAxessSettings() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.frontend.FRONTEND_ACESS_AXESS_SETTINGS
        )
    },
    async appUserCanEditPowerBi() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.shopApi.EDIT_EXTERNAL_URL
        )
    },
  },
}
</script>
